import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

// Generic feature landing page for Tap to Pay / Payment Links / Storefront / FLIX AI.
const FeaturePage = ({ eyebrow, title, titleAccent, description, bullets, image, onDownload }) => {
  return (
    <div className="bg-gradient-to-b from-[#e8f5ee] to-white pt-40 pb-24 px-6 min-h-screen">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-sm font-semibold text-[#0e9f6e] mb-4">{eyebrow}</p>
          <h1 className="font-display text-5xl sm:text-6xl font-700 text-[#0f1712]">
            {title} <span className="text-[#0e9f6e]">{titleAccent}</span>
          </h1>
          <p className="text-lg text-[#0f1712]/60 mt-6 max-w-md leading-relaxed">{description}</p>
          <ul className="mt-8 space-y-3">
            {bullets.map((b) => (
              <li key={b} className="flex items-center gap-3 text-[#0f1712]/75 text-[15px]">
                <span className="w-6 h-6 rounded-full bg-[#0e9f6e]/15 flex items-center justify-center shrink-0">
                  <Check size={14} className="text-[#0e9f6e]" />
                </span>
                {b}
              </li>
            ))}
          </ul>
          <button onClick={onDownload} className="mt-9 inline-flex items-center gap-2 bg-[#0e9f6e] text-white rounded-xl px-7 py-4 text-sm font-semibold hover:bg-[#0c8a60] hover:scale-[1.02] active:scale-95 transition-all">
            Get started free <ArrowRight size={16} />
          </button>
        </div>
        <div className="overflow-hidden rounded-[2rem] shadow-[0_25px_70px_rgba(15,23,18,0.15)] aspect-[4/3]">
          <img src={image} alt={title} className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
};

export default FeaturePage;
